var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBack = function SvgBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    d: "M4.201 7.5c2.474-4.303 7.951-5.778 12.235-3.293.71.414 1.355 1.05 1.804 1.604L21 3.857V12l-7.714-2.687 2.409-1.707a3.248 3.248 0 0 0-.826-.671 5.807 5.807 0 0 0-7.953 2.14c-1.607 2.798-.653 6.375 2.131 7.99A5.807 5.807 0 0 0 17 14.925l2.714 1.574c-2.473 4.304-7.95 5.779-12.234 3.294S1.728 11.805 4.2 7.5z"
  })));
};
export { SvgBack as ReactComponent };
export default __webpack_public_path__ + "eb9196dbc4d8819a9cfeba11d6e3c04b.svg";